module.exports = __webpack_public_path__ + "img/slc.5a5be6ed.jpg";